module.exports = __webpack_public_path__ + "img/dl-outdoor.4d13f92d.jpg";